import { useEffect, useState } from "react"
import { useRoutesHooks } from "../../../../../features/routes"
import { DetailWrapper, O, SpinnerDiv } from "../../../../../features/ui"
import { Delivery, DeliveryOrder, useDeliveryOrderLoaders, useDeliveryLoaders } from "../../../../deliveries"
import { PurchaseDetail } from "./purchaseDetail"
import { PurchaseOrder } from "../../../state/types"
import { Ticket, useTicketLoaders } from "../../../../administration"

export const Loader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
  const purchase = dataType! as PurchaseOrder

    const [ready, setReady] = useState(false)
    const [deliveryOrders, setDeliveryOrders] = useState<DeliveryOrder[]>([])
    const [deliveries, setDeliveries] = useState<Delivery[]>([])
    const [tickets, setTickets] = useState<Ticket[]>([])

    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const deliveryLoaders = useDeliveryLoaders()
    const ticketLoaders = useTicketLoaders()

    const load = async () => {
        const { loadOperationDeliveryOrders } = deliveryOrderLoaders()
        const loadedDeliveryOrders = await loadOperationDeliveryOrders(purchase.id)
        setDeliveryOrders(loadedDeliveryOrders)
        const { loadOperationDeliveries } = deliveryLoaders()
        const loadedDeliveries = await loadOperationDeliveries(purchase.id)
        setDeliveries(loadedDeliveries)
        const { loadParentTickets } = ticketLoaders()
        const loadedTickets = await loadParentTickets(purchase.id)
        setTickets(loadedTickets)
    }
    
    useEffect(() => {
        load().then(() => setReady(true))
    }, [])

    return ready ? (
        <PurchaseDetail
            purchase={purchase}
            deliveryOrders={deliveryOrders}
            deliveries={deliveries}
            tickets={tickets}
        />
    ) : <SpinnerDiv />
}

export const PurchaseDetailLoader = () => (
    <DetailWrapper>
        <Loader />
    </DetailWrapper>
)
